// extracted by mini-css-extract-plugin
export default {"primary-buttons":"CloseTabModal_primary-buttons__MWsUa","primaryButtons":"CloseTabModal_primary-buttons__MWsUa","buttonsWrapper":"CloseTabModal_buttonsWrapper__bf6RC"};